import React, { useMemo, useState } from "react";
import { TouchableOpacity, View } from "react-native";
import BoilerPlate from "../boilerPlate/BoilerPlate";
import CustomHeader from "../../customHeader/CustomHeader";
import { ColorTokens, DividerSizeTokens, FontSizeTokens, IconSizeTokens, IconTokens, TypographyTypeDLS } from "@voltmoney/schema";
import Typography from "../../typography/Typography";
import Divider from "../../divider/Divider";
import Icon from "../../icon/Icon";
import { isFontMobile } from "../../stack/utils";
import InterestDetails from "./InterestDetails";
import LoanDetails from "./LoanDetails";
import NeedHelpDC from "../NeedHelpDC";
import { addCommasToNumber } from "../utils";
const MyLoanProfile = ({ height, getLoanDetails, contactUsDetails, backAction, triggerAction, }) => {
    const [activeIndex, setActiveIndex] = useState([1, 2]);
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const loanDetailsObj = getLoanDetails?.data;
    const interestDetails = loanDetailsObj?.interestDetails;
    const loanDetails = loanDetailsObj?.loanDetails;
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    const headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { title: 'My loan details', triggerAction: triggerAction, needHelpAction: handleNeedHelp, goBackAction: backAction, showNeedHelpNewArch: true }));
    }, []);
    const handleArrowPress = (item) => {
        if (activeIndex.includes(item)) {
            setActiveIndex((prevItems) => prevItems.filter((val) => val !== item));
        }
        else
            setActiveIndex((prevItems) => [
                ...prevItems,
                item
            ]);
    };
    const renderContent = () => {
        return (React.createElement(View, { style: { marginVertical: 24, marginHorizontal: 16 } },
            React.createElement(View, { style: { padding: 12, borderWidth: 1, borderRadius: 12, borderColor: '#E4E7EC' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal, label: "Total credit limit" }),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        alignItems: 'center',
                        marginTop: 4
                    } },
                    React.createElement(Typography, { label: `₹`, fontWeight: '700', color: ColorTokens.Secondary_100, fontSize: isFontMobile() ? FontSizeTokens.XXXXL : FontSizeTokens.XXL, lineHeight: isFontMobile() ? 40 : 32 }),
                    React.createElement(Typography, { label: addCommasToNumber(loanDetails?.actualLoanAmount), typeDLS: TypographyTypeDLS.H1B, color: ColorTokens.Secondary_100 })),
                React.createElement(View, { style: { marginVertical: 12 } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal, label: "Pledged mutual funds value" }),
                React.createElement(View, { style: { marginTop: 4 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0B, color: ColorTokens.Grey_Night, label: `₹${addCommasToNumber(loanDetails?.totalValueOfAssetsPledged)}` }))),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(TouchableOpacity, { activeOpacity: 1, style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }, onPress: async () => {
                        handleArrowPress(1);
                    } },
                    React.createElement(Typography, { label: 'Interest details', color: ColorTokens.Grey_Night, typeDLS: TypographyTypeDLS.B1S }),
                    React.createElement(Icon, { name: activeIndex.includes(1) ? IconTokens.UpsideArrow : IconTokens.DownArrow, size: IconSizeTokens.SM, color: ColorTokens.Grey_Night })),
                activeIndex.includes(1) &&
                    React.createElement(View, { style: { padding: 12, borderRadius: 12, borderWidth: 1, borderColor: '#E4E7EC', marginTop: 16 } },
                        React.createElement(InterestDetails, { loanDetailsObj: interestDetails }))),
            React.createElement(View, { style: { marginVertical: 24, marginHorizontal: -16 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
            React.createElement(View, null,
                React.createElement(TouchableOpacity, { activeOpacity: 1, style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }, onPress: async () => {
                        handleArrowPress(2);
                    } },
                    React.createElement(Typography, { label: 'Loan details', color: ColorTokens.Grey_Night, typeDLS: TypographyTypeDLS.B1S }),
                    React.createElement(Icon, { name: activeIndex.includes(2) ? IconTokens.UpsideArrow : IconTokens.DownArrow, size: IconSizeTokens.SM, color: ColorTokens.Grey_Night })),
                activeIndex.includes(2) &&
                    React.createElement(View, { style: { padding: 12, borderRadius: 12, borderWidth: 1, borderColor: '#E4E7EC', marginTop: 16 } },
                        React.createElement(LoanDetails, { loanDetailsObj: loanDetails })))));
    };
    return (React.createElement(BoilerPlate, { height: height, headerChild: headerChild, scrollEnabled: showNeedHelp ? false : true, bottomChildren: React.createElement(React.Fragment, null, showNeedHelp &&
            React.createElement(View, { style: { paddingBottom: 12 } },
                React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails }))), backgroundColor: ColorTokens.White },
        React.createElement(React.Fragment, null, renderContent())));
};
export default MyLoanProfile;
